import * as React from 'react';
import { t } from 'i18next';

import { BaseHamburgerTab } from './BaseHamburgerTab';
import { HamburgerTab } from '../../constants/Enums';
import { HamburgerContentWrapper } from './HamburgerContentWrapper';
import { LongButton } from '../LongButton';
import { PRODUCT_NAME } from '../../App';

export class HelpIconsTab extends BaseHamburgerTab<{}> {
    protected previous: HamburgerTab = HamburgerTab.HELP;

    public render(): JSX.Element {
        return (
            <HamburgerContentWrapper className={this.getCSSClass()} header={this.header()}>
                {this.getIcons().map((icon, index: number) => {
                    return (
                        <div className="long-button-group" key={index}>
                            <LongButton className={'with-icon short-border ' + icon.cssIcon}>{icon.name}</LongButton>
                            <LongButton className="with-icon short-border">{icon.description}</LongButton>
                        </div>
                    );
                })}
            </HamburgerContentWrapper>
        );
    }

    protected getLabel(): string {
        return t('Icons');
    }

    protected getIcons(): Array<{cssIcon: string, name: string, description: string}> {
        return [
            // Taskbar Icons
            {cssIcon: 'icon-camera-pers-dark', name: t('Perspective'), description: t('Use perspective projection.')},
            {cssIcon: 'icon-camera-ortho-dark', name: t('Orthographic'), description: t('Use orthographic view.')},
            {cssIcon: 'icon-camera-front-dark', name: t('Front'), description: t('Use front view.')},
            {cssIcon: 'icon-camera-top-dark', name: t('Top'), description: t('Use top view.')},
            {cssIcon: 'icon-camera-left-dark', name: t('Left'), description: t('Use left side view.')},
            {cssIcon: 'icon-camera-right-dark', name: t('Right'), description: t('Use right side view.')},
            {cssIcon: 'icon-camera-back-dark', name: t('Rear'), description: t('Use rear view.')},
            {cssIcon: 'icon-camera-bottom-dark', name: t('Bottom'), description: t('Use bottom view.')},
            {cssIcon: 'icon-undo-dark', name: t('Undo'), description: t('Undo the last action.')},
            {cssIcon: 'icon-redo-dark', name: t('Redo'), description: t('Redo the last action.')},
            {cssIcon: 'icon-delete-dark', name: t('Delete'), description: t('Delete the current selection.')},
            // Workspace Icons
            {cssIcon: 'icon-config-dark', name: t('Floor Plan'), description: t('Open the workspace options.')},
            {cssIcon: '', name: t('Floor Plan'), description: t('Hide workspace.')},
            {cssIcon: 'icon-pen-dark', name: t('Floor Plan'), description: t('Show neutral workspace and pick a workspace color.')},
            {
                cssIcon: 'icon-upload-dark', name: t('Floor Plan'),
                description: t('Take a picture of a floor plan and use it for your space or import a locally-saved floor plan.')
            },
            {cssIcon: 'icon-pen-dark', name: t('Floor Plan'), description: t('Optimize the floor plan display.')},
            // Menu Icons
            {cssIcon: 'icon-multiselect-dark', name: t('Multi Selection'), description: t('Enable this function to select several objects at once.')},
            {
                cssIcon: 'icon-rectselect-dark', name: t('Rectangular Selection'),
                description: t('Click on a point and drag to highlight an area in which all objects will be selected.')
            },
            {cssIcon: 'icon-clone-dark', name: t('Clone'), description: t('Copy the current selection.')},
            {cssIcon: 'icon-photo-dark', name: t('Snapshot'), description: t('Save an image of the current view to your photo album.')},
            {
                cssIcon: 'icon-share-dark', name: t('Save'),
                description: t('Open the mobile operating system\'s Share menu (app) or download a PDF of the article list (web and app).')
            },
            {
                cssIcon: 'icon-dotdotdot-dark', name: t('Further options'),
                description: t('Open further options.')},
            {
                cssIcon: 'icon-hamburger-dark', name: t('Menu (3 lines)'),
                 description: t('Open the Project Manager as well as the menu with settings.')
            },
            {
                cssIcon: 'icon-config-dark', name: t('Show working area'),
                description: t('Close all menus and work in full-screen mode.')
            },
            {
                cssIcon: 'icon-catalog-dark', name: t('Catalogs'),
                description: t('Select objects from your subscribed catalogs.')
            },
            {
                cssIcon: 'icon-property-dark', name: t('Configure'),
                description: t('Configure selected objects in accordance with your product logic.')
            },
            {
                cssIcon: 'icon-list-dark', name: t('Article List'),
                description: t('Display the article list with all objects.')},
            {
                cssIcon: 'icon-airplane-dark', name: t('Share'),
                description: t('Send images, article lists and CAD data via e-mail or open them in a compatible app.')
            },
            {
                cssIcon: 'icon-download-dark', name: t('Download'), description: t('Download images, article lists and CAD data of the current planning.')},
            // Features in Project Menu
            {
                cssIcon: 'icon-new-dark', name: t('New'), description: t('Create a new project.')},
            {
                cssIcon: 'icon-disk-dark', name: t('Save'), description: t('Save the current project.')},
            {
                cssIcon: 'icon-clone-dark', name: t('Save as copy'),
                description: t('Save the current state of your project under a new name. You will automatically continue to work in the new project.')
            },
            {
                cssIcon: 'icon-bag-dark', name: t('My projects'), description: t('Switch to project manager.')},
            {
                cssIcon: 'icon-save-dark', name: t('Save as'),
                description: t('Export {{productName}} projects to your cloud or device.', {productName: PRODUCT_NAME})
            },
            {
                cssIcon: 'icon-news-dark', name: t('News'), description: t('Read about important new {{productName}} features.', {productName: PRODUCT_NAME})},
            {
                cssIcon: 'icon-setting-dark', name: t('Settings'),
                description: t('Define general project settings: Floor space appearance, language settings, measuring unit or image file type.')
            },
        ];
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/HelpIconsTab.tsx